import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash'
import IntlMessages from 'util/IntlMessages';

const phasesDefalt = [
  {
    value: '1',
    label: <IntlMessages id="phasesDefalt.Phase1"/>
  },
  {
    value: '2',
    label: <IntlMessages id="phasesDefalt.Phase2"/>,
  },
  {
    value: '3',
    label: <IntlMessages id="phasesDefalt.Phase3"/>,
  },
  {
    value: '4',
    label: <IntlMessages id="phasesDefalt.Phase4"/>,
  },
  {
    value: '5',
    label: <IntlMessages id="phasesDefalt.Phase5"/>,
  },
  {
    value: '6',
    label: <IntlMessages id="phasesDefalt.Phase6"/>,
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(0),
    //   width: '28ch',
    },
  },
}));

export default function InputComponent(props) {
  const classes = useStyles();
  const [phase, setPhase] = React.useState(props.phase);
  const [phases, setphases]=React.useState(phasesDefalt)
  
  const createData=()=>{
    if(isEmpty(props.ProspektFaslist)){ return phasesDefalt}
    let data = props.ProspektFaslist.map((n)=>{
        return {
          value: n.Ordering,
          label: n.FasNamn           
        }
    })
    return data;
  }
  const handleChangeF=(e)=>{
    setPhase(e.target.value)
    props.handleChange(e)
  }
  //
  React.useEffect(()=>{
    setPhase(props.phase)
   
  })
  const DataList = createData()
  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div>
        <TextField
          variant="outlined"
          name="Fas"
          fullWidth
          label={<IntlMessages id="Phase"/>}
          size="small"
          error={isEmpty(phase)}
          select
          value={phase}
          onChange={handleChangeF}
          SelectProps={{
            native: true,
          }}
          InputLabelProps={{
            shrink: true,
        }}
        >
          <option value=""><IntlMessages id="Choose"/></option>
          {DataList.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </TextField>
      </div>
    </form>
  );
}